// extracted by mini-css-extract-plugin
export default {"questionText":"SurveyQuestionsEditor_questionText__ALsly","questionType":"SurveyQuestionsEditor_questionType__+q7mg"};